// extracted by mini-css-extract-plugin
export var ellipse = "ellipse-module--ellipse--e35b0";